import AccesoServicios from "./AccesoServicios";
import { HttpClient, RestOptions, RestResponse } from "../../../comun/js--base--unimat--local";
import { keys } from "lodash";

export class RestProxy implements HttpClient {

    constructor(private AccesoServicios: AccesoServicios, private _baseUrl: string) {

    }

    request<R>({ method, url, queryParams, data, copyFn, options }: { method: string, url: string, queryParams?: any, data?: any, copyFn?: (data: R) => R, options?: RestOptions }): RestResponse<R> {

        // soporte para options
        if (options) {

            // soporte options.qparms
            if (options.qparams) {

                queryParams = queryParams || {}

                keys(options.qparams).forEach(o => {
                    queryParams[o] = options.qparams[o]
                })
            }
        }

        return this.AccesoServicios._restrequest(
            {
                method,
                url: this._baseUrl + url,
                queryParams,
                data,
                options,
                copyFn
            })
    }
}
